export default __webpack_public_path__ + "media/images/mailer/logo-cc888e6a953d616d87889bfa4b47fb62.png";